<template>
    <picture class="block absolute top-0 left-0 w-full h-full" v-if="image">
      <template v-if="image.mime_type !== 'image/svg+xml' && image.mime_type !== 'image/gif'">
        <source
            type="image/webp"
            :srcset="`${image.sizes.placeholder}.webp`"
            :data-srcset="`${image.url}.webp 1440w,
                ${image.sizes.large}.webp 600w,
                ${image.sizes.medium_large}.webp 320w`">
        <source
            :type="`${image.mime_type}`"
            :srcset="`${image.sizes.placeholder}`"
            :data-srcset="`${image.url ? image.url + ' 1440w,' : ''}
                ${image.sizes.large} 600w,
                ${image.sizes.medium_large} 320w`">
        <img :key="`bg-image-${image.id}`"
             class="lazyload lazyload-fade-in w-full h-full object-cover object-center"
             :class="imageClass"
             data-expand="-50" :src="`${image.sizes.placeholder}`"
             :data-src="`${image.url}`" :alt="`${image.alt}`"
        >
      </template>
      
      <img v-else
           :key="`bg-image-${image.id}`"
           class="lazyload lazyload-fade-in w-full h-full object-cover object-center"
           :class="imageClass"
           data-expand="-50" :src="`${image.sizes.placeholder}`"
           :data-src="`${image.url}`" :alt="`${image.alt}`"
      >
    </picture>
</template>

<script>
export default {
  name: "ImageBG",
    props: ['image', 'imageClass']
}
</script>

<style scoped>

</style>